
import * as types from './types';
import { implementSetAllNavTabDetailsMutation } from '../../../../dt-plugins/sidewindow/nav-tab';
export const distributionAccountMutations = {
  [types.AccountDistributionData.SET.ALL](state, payload) {
    state.accountDistributionData = payload;
  },
  [types.AccountDistributionData.SET.SINGLE](state, payload) {
    state.accountDistributionData = payload;
  },
  [types.AccountList.SET.ALL](state, payload) {
    state.accountList = payload;
  },
  [types.AccountList.DELETE.SINGLE](state, payload) {
    let list = state.accountList?.accounts;
    list = list.filter(e => e.account_id !== payload.account_id)
    state.accountList = {
      accounts: [
        ...list
      ]
    }
  },
  [types.AccountList.UPDATE.SINGLE](state, payload) {
    state.accountList.accounts = state.accountList.accounts.map(e => {
      if (e.account_id == payload.kVal) {
        return {
          ...e,
          [payload.name]: payload.value
        };
      } else {
        return e;
      }
    })
  },

  ...implementSetAllNavTabDetailsMutation(types.DistributionAccountDetails, 'distributionAccountDetails'),
}